<template>
  <div style="width: 100%">
    <div style="display: flex; justify-content: space-between; position: relative; top: 12px;">
      <label class="typo__label">{{ label }}</label>
      <a v-if="showSelectAll && !textMode" href="#" class="select-all-link" @click.prevent="toggleSelectAll">{{ isAllSelected ? deselectAllText : selectAllText }}</a>
    </div>
    <template v-if="textMode">
      <input
        type="text"
        :placeholder="placeholder"
        :value="internalValue"
        @input="$emit('input', $event.target.value)"
        style="margin-top: 6px !important; border: 1px solid #d1d5db !important; border-radius: 5px !important; padding: 0 12px !important; font-size: 14px !important; width: 100% !important; height: 40px !important;"
      />
    </template>
    <template v-else>
      <multiselect
        class="new-style"
        :id="id"
        v-model="internalValue"
        :options="options"
        :multiple="true"
        :taggable="false"
        :show-labels="false"
        :clear-on-select="false"
        :close-on-select="false"
        :limit-text="(count) => `+ ${count}`"
        :limit="limit"
        :group-select="groupSelect"
        :group-label="groupLabel"
        :group-values="groupValues"
        :searchable="true"
        :loading="loading"
        :options-limit="50"
        :internal-search="false"
        :hide-selected="true"
        :track-by="trackBy"
        :label="labelKey"
        :placeholder="placeholder"
        @search-change="$emit('search-change', $event)"
        :disabled="disabled"
        @close="$emit('close')"
      >
        <template #option="props">
          <template v-if="groupLabel && groupValues">
            <span class="option__title" v-if="props.option?.$isLabel">
              {{ props.option.$groupLabel }}
              <span class="label-info label-info--deselected">Selecionar todos</span>
              <span class="label-info label-info--selected">Remover todos</span>
            </span>
            <span class="d-flex option__item option__item--indented" v-else>
              {{ props.option[labelKey] }}
            </span>
          </template>
          <template v-else>
            <span class="d-flex option__item">
              {{ props.option[labelKey] }}
            </span>
          </template>
        </template>
        <template #placeholder>
          <span class="select-title">{{ placeholder }}</span>
        </template>
        <span slot="noOptions">Pesquise pelo item</span>
        <span slot="noResult">Nenhum encontrado</span>
        <div slot="limit" class="multiselect__tag limit">+{{ (internalValue?.length || 0) - limit }}</div>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
    </template>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'GenericFilter',
  components: { Multiselect },
  props: {
    label: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    value: { type: [Array, String], default: '' },
    loading: { type: Boolean, default: false },
    limit: { type: Number, default: 5 },
    placeholder: { type: String, default: 'Selecione' },
    showSelectAll: { type: Boolean, default: false },
    selectAllText: { type: String, default: 'Selecionar todos' },
    deselectAllText: { type: String, default: 'Remover todos' },
    id: { type: String, default: '' },
    trackBy: { type: String, default: 'id' },
    labelKey: { type: String, default: 'name' },
    groupLabel: { type: String, default: '' },
    groupValues: { type: String, default: '' },
    groupSelect: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    textMode: { type: Boolean, default: false },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    isAllSelected() {
      // Modo agrupado
      if (this.groupLabel && this.groupValues) {
        const allItems = this.options.flatMap(group => group[this.groupValues] || []);
        return allItems.length > 0 && allItems.every(item => this.value.some(sel => sel[this.trackBy] === item[this.trackBy]));
      }
      // Modo simples
      return Array.isArray(this.options) && this.options.length > 0 && this.options.every(item => this.value.some(sel => sel[this.trackBy] === item[this.trackBy]));
    }
  },
  methods: {
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.$emit('input', []);
      } else {
        if (this.groupLabel && this.groupValues) {
          const allItems = this.options.flatMap(group => group[this.groupValues] || []);
          this.$emit('input', allItems.slice());
        } else {
          this.$emit('input', this.options.slice());
        }
      }
    }
  }
};
</script>

<style scoped>
.select-all-link {
  color: var(--Default-gray-500, #6B7280);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.generic-filter-input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  height: 32px;
  padding: 0 12px;
  font-size: 14px;
  font-family: Inter;
  width: 100%;
  box-sizing: border-box;
}
.option__item--indented {
  padding-left: 24px;
}
</style> 